import { take, put, fork, call } from 'redux-saga/effects';
// import { push, goBack } from 'react-router-redux';
import {reset} from 'redux-form';
import {
  PASSWORD_RESET,
  RESET_STATE,
  PASSWORD_RESET_FAIL,
  PASSWORD_RESET_FLAG,
  GET_HISTORY,
  RESEND_OTP,
  OTP_NOT_SENT
} from '../actions/actionConstants'
import { post } from '../api';

function* resetPasswordSaga() {
  while (true) {
    const history = yield take(GET_HISTORY);
    const request = yield take(PASSWORD_RESET);
    const { payload } = request;
    const fetchDataResponse = yield call(
      post,
      '/user/password/add', payload);
    if (fetchDataResponse.status >= 400 || fetchDataResponse.status >= 401) {
      yield put({
        type: PASSWORD_RESET_FAIL,
        error: fetchDataResponse.body.errors[0],
      });
      console.log('Err Response from Saga: ',fetchDataResponse.body.errors[0])
    }
     else if (fetchDataResponse.status === 200 || fetchDataResponse.status === 201) {
      yield put({
        type: PASSWORD_RESET_FLAG,
        flag: true,
      });
      yield put({
        type: RESET_STATE,
      });
      //resetting the form 'login' on successfull password change
      yield put(reset('login'))
      //resetting the form 'forgot_password' on successfull password change
      yield put(reset('forgot_password'))  
      const lastLocation = JSON.parse(window.localStorage.getItem('lastLocation'))
       console.log('Data Response from Saga: ',lastLocation)
      // yield put(push(lastLocation));
      // yield put(goBack());
      // console.log('History', history)
      history.obj.push(lastLocation);
      
    }
  }
}

function* resendOTPSaga() {
  while (true) {
    // debugger;
    const request = yield take(RESEND_OTP);
    const { payload } = request;
    const fetchDataResponse = yield call(
      post,
      '/user/otp', payload);
    if (fetchDataResponse.status >= 400 || fetchDataResponse.status >= 401) {
      yield put({
        type: OTP_NOT_SENT,
        error: fetchDataResponse.body.errors[0],
      });
      console.log('Err Response from Saga: ', fetchDataResponse.body.errors[0])
    }
    else if (fetchDataResponse.status === 200 || fetchDataResponse.status === 201) {
      yield put({
        type: RESET_STATE,
      });
    }
  }
}

export default function* () {
  yield fork(resetPasswordSaga);
  yield fork(resendOTPSaga);
}



// WEBPACK FOOTER //
// ./src/sagas/PasswordResetSaga.js